export default __webpack_public_path__ + "static/media/type3_4in.937eb643.svg";